import React from 'react'

import Layout from '../layouts/zh'
import SEO from '../components/seo'
import Bubble from '../components/Bubble'
import IntroBox from '../components/IntroBox'
import IllustrationBox from '../components/IllustrationBox'
import Testimonial from '../components/Testimonial'

import FlickitySlider from '../components/FlickitySlider'
import AnnualReviewSlider from '../components/AnnualReviewSlider'
import FinancialReportAndPersonnelStructure from '../components/FinancialReportAndPersonnelStructure'
import MoreText from '../components/MoreText'
import VideoButton from '../components/VideoButton'

//  Data
const TeamMembers = require('../data/TeamMembers')
const Awards = require('../data/Awards')
const Schools = require('../data/Schools')
const CollegeAchievements = require('../data/CollegeAchievements')
const StudentActivities = require('../data/StudentActivities')
const StudentStories = require('../data/StudentStories')

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="精銳之師" />

    <div
      className="bg-center bg-cover py-12 md:bg-center-x-61p lg:bg-center"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/bg-elite-teacher.jpg)` }}
    >
      <div className="container" data-aos="fade-up" data-aos-delay={400} data-aos-duration={1200} id="embrace-the-present-and-face-future-challenges">
        <Bubble className="w-full md:w-1/2"
          title="精銳之師"
          subtitle="成就今日　挑戰未來"
        >
          <div className="text-sm md:text-base leading-relaxed text-justify">
            <p className="mb-4">旅遊學院於1995年成立，是一所澳門特別行政區政府社會文化司的公立高等教育機構，提供一系列旅遊範疇的學位課程和專業培訓，包括酒店、旅遊、文化遺產、會展、零售及市場推廣、休閒娛樂、康體活動、文化創意及廚藝等。</p>
            <p>旅遊學院下設旅遊高等學校和旅遊及酒店業學校，分別提供四年制學士學位課程以及專業培訓課程。</p>
          </div>
        </Bubble>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap -mx-2">
          {
            Schools.map((school, i) => (
              <div key={i} className="w-full md:w-1/2 flex" data-aos={`${i == 0 ? 'fade-right' : 'fade-left'}`} data-aos-delay={850}>
                <IntroBox className="mx-2 text-sm md:text-base h-full"
                  title={school.title['zh']}
                  more
                  link={`/${school.link['zh']}`}
                  image={school.image}
                >
                  {school.description['zh']}
                </IntroBox>
              </div>
            ))
          }
        </div>
      </div>
    </div>

    <div className="container py-8 md:py-12">
      {/*<h2 className="text-3xl md:text-5xl text-yellow-500 text-center mb-8 md:mb-12">College achievement</h2>*/}

      <div className="flex flex-row flex-wrap -mx-8 md:mb-12" id="highlights">
        {
          CollegeAchievements.illustrationItems.map((item, i) => (
            <div key={i} className="w-1/2 md:w-1/4 mb-12" data-aos="fade-up" data-aos-delay={i * 150}>
              <div className="mx-8">
                <IllustrationBox
                  number={item.number}
                  image={item.image}
                  title={item.title['zh']}
                  text={item.text['zh']}
                  className="text-3xl"
                  alignment="left"
                />
              </div>
            </div>
          ))
        }
      </div>

      <FlickitySlider className="mb-8 md:mb-12">
        {
          CollegeAchievements.listItems.map((item, i) => (
            <div key={i} className="w-full md:w-1/2 p-4">
              <Testimonial
                title={item.title['zh']}
                color={item.color}
              >
                {
                  item.content['zh'].map((text, j) => (
                    <p key={j} className="mb-4">
                      { text }
                    </p>
                  ))
                }
              </Testimonial>
            </div>
          ))
        }
      </FlickitySlider>
    </div>

    <div className="bg-gray-200 py-8 md:py-12 md:pb-24" id="efficient-management">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-blue-500 text-center mb-2" data-aos="fade-down">管理團隊</h2>
        <div className="text-left mx-auto max-w-xl text-sm md:text-base mb-8 md:mb-12 font-normal text-justify" data-aos="fade-up">
          高效決策是旅遊學院管理團隊的核心理念，團隊成員經驗豐富，在確保學院順利運作的同時，更好地履行使命。
        </div>

        <FlickitySlider>
          {
            TeamMembers.map((member, i) => (
              <div key={i} className="w-full md:w-1/4 mb-12 text-center">
                <div className="flex flex-col items-center mx-4">
                  <img src={`/AnnualReport2017-2018${member.image}`} alt="member" className="rounded-full w-40 h-40 mb-2" />

                  <div className="w-full text-2xl text-blue-500">
                    { member.name['zh'] }
                  </div>
                  <div className="w-full mb-2" dangerouslySetInnerHTML={{ __html: member.title['zh'] }}></div>
                  <MoreText limitTextLength={member.textLength || 450} className="w-full text-sm font-normal text-left">
                    { member.description['zh'] }
                  </MoreText>
                </div>
              </div>
            ))
          }
        </FlickitySlider>
      </div>
    </div>

    <div className="container py-8 md:py-12 md:pb-24" id="honours-and-awards">
      <h2 className="text-3xl md:text-5xl text-yellow-500 text-center mb-2" data-aos="fade-down">榮譽和獎項</h2>
      <div className="text-left mx-auto max-w-xl text-sm md:text-base mb-8 md:mb-12 font-normal text-justify" data-aos="fade-up">
        作為不斷追求卓越的旅遊教育機構，旅遊學院優質的教學質量和對社會的貢獻得到了各界的肯定。也贏得澳門、中國內地和世界其他國家及地區機構頒發的榮譽和獎項：
      </div>

      <FlickitySlider>
        {
          Awards.map((award, i) => (
            <div key={i} className="w-1/2 md:w-1/4 mb-12 text-center">
              <div className="mx-8">
                <div className="mx-auto rounded-full bg-gray-200 w-32 h-32 flex items-center justify-center mb-4">
                  <img src={`/AnnualReport2017-2018${award.image}`} className="w-24 h-24" alt="" />
                </div>
                <div className="text-left text-justify">
                  { award.content['zh'].map((text, j) => {
                      return (
                        <p key={j} className={`mb-1 ${(j === 0 ? 'text-yellow-500' : 'text-gray-700 text-sm')}`}>{ text }</p>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          ))
        }
      </FlickitySlider>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" data-aos="fade-up">
      <div className="container">
        {
          <FinancialReportAndPersonnelStructure
            langKey={props.pageContext.langKey}
            description1="過去一個財政年度，旅遊學院繼續保持穩健的財務收支狀況，反映出管理層堅持嚴謹決策及科學管理。"
            description2="旅遊學院在2017/18學年致力吸引和留住高素質的員工。全職教學人員的數量與上一學年相似。全職人員的數目上升1.76%。"
          />
        }
      </div>
    </div>

    <div className="container py-8 md:py-12 md:pb-24" id="year-in-review">
      <h2 className="text-3xl md:text-5xl text-blue-500 text-center mb-8 md:mb-12" data-aos="fade-down">年度回顧</h2>

      <AnnualReviewSlider langKey={props.pageContext.langKey} />
    </div>

    <div className="bg-gray-200 py-8 md:py-12 md:pb-24" id="student-activities">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-8 md:mb-12" data-aos="fade-down">學生活動</h2>

        <FlickitySlider>
          {
            StudentActivities.map((activity, i) => (
              <div key={i} className="w-full md:w-1/2 p-4">
                <Testimonial
                  title={activity.title['zh']}
                  color={i%2===0 ? 'blue' : 'orange'}
                >
                  {
                    activity.content['zh'].map((text, j) => (
                      <p key={j} className="mb-4" dangerouslySetInnerHTML={{ __html: text }}></p>
                    ))
                  }
                  { (activity.video && activity.video['zh']) ? <p><VideoButton url={activity.video['zh']} /></p> : null }
                </Testimonial>
              </div>
            ))
          }
        </FlickitySlider>
      </div>
    </div>

    <div className="container py-8 md:py-12 md:pb-24">
      <h2 className="text-3xl md:text-5xl text-blue-500 text-center mb-8 md:mb-12" data-aos="fade-down">學生故事</h2>

      <FlickitySlider>
        {
          StudentStories.map((story, i) => (
            <div key={i} className="w-full flex flex-row">
              <div className="w-full mx-4">
                <div className="text-lg mb-4">{ story.title['zh'] }</div>
                <div className="font-normal text-justify">
                  {
                    story.content['zh'].map((text, j) => (
                      <p key={j} className="mb-4" dangerouslySetInnerHTML={{ __html: text }}></p>
                    ))
                  }
                { (story.video && story.video['zh']) ? <p><VideoButton url={story.video['zh']} /></p> : null }
                </div>
              </div>
            </div>
          ))
        }
      </FlickitySlider>
    </div>
  </Layout>
)

export default IndexPage
